module.exports = __webpack_public_path__ + "static/img/doomyoga-music.7714605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/doomyoga-music.png
// module id = pKi0
// module chunks = 0